export default function Index() {
 
    return (
      <div className="index-page-content">
          <h1>Welcome to Wildlife Diaries</h1>
      </div>
    );
  }
  